import { render } from "./ModalCadastrarSprint.vue?vue&type=template&id=2e35d226&scoped=true"
import script from "./ModalCadastrarSprint.vue?vue&type=script&lang=js"
export * from "./ModalCadastrarSprint.vue?vue&type=script&lang=js"

import "./ModalCadastrarSprint.vue?vue&type=style&index=0&id=2e35d226&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e35d226"]])

export default __exports__